<template>
  <div :class="'statusLight '+statusCol">
    {{label}}
  </div>
</template>

<script>
export default {
  name: 'textInput',
  props: ["status","label"],

  computed:{
    statusCol(){
      if( this.status=="none"){
         return "none"
      }else if( this.status){
        return "connected"
      }else{
        return "disconnected"
      }
    }
  }
    
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .statusLight{
  border-radius:5px;
   font-size:inherit;
   
  padding:10px 10px;
   margin:5px;
   background-color:#ff0;
   
  }
  .connected{
    color:#fff;
    background-color:green;
  }
  .disconnected{
    color:#fff;
    background-color:orange;
  }
  .none{
    color:#fff;
    background-color:#000;
  }
</style>
